/**
 * product-attribute-table
 */

// Module dependencies

import { Grid } from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import facetValueIdGet from '../../02-molecules/ag-grid-facets/facetValueId';

// Module styles
import './_ag-grid.scss';
import './_ag-grid-theme.scss';

// Module template
import './_ag-grid.twig';

export const name = 'ag-grid';

export const defaults = {
  dummyClass: 'js-ag-grid-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Enables AGGrid component.
 *
 * @param {jQuery} $context - A piece of DOM
 */
(function ($, Drupal, $context) {
  const module = {
    /**
     * Module name.
     */
    name: 'agGrid',
    /**
     * Drupal environment flag.
     */
    drupal: !!window.Drupal && !!window.Drupal.behaviors,

    /**
     * Initialized flag.
     */
    init: false,

    /**
     * Drupal behavior to attach.
     */
    instance: {
      state: {
        /**
         * AG Grid instances.
         */
        instances: [],
        /**
         * External filters.
         */
        externalFilters: [],
        /**
         * Filter values that add results to the result set when thet are added
         * to the external filters. (Used for facets)
         */
        availableFiltersValues: [],
      },
      attach(context) {
        // Checking whether context is document or not to
        // avoid ajax related calls and duplicating the table
        // on every ajax request.
        if (context === document) {
          this.initGrid(context);
        }
      },
      /**
       * Initializes the AG Grid.
       *
       * @param {HTMLDocument|HTMLElement} context
       *   An element to attach behaviors to.
       */
      initGrid(context) {
        const self = this;
        $('.ag-grid', context).each(function fn() {
          const $el = $(this);
          const id = $el.data('instance-id') || '';
          const gridType = $el.data('grid-type') || 'standard';
          const gridOptions = {
            metadata: {
              gridType,
              colSpanDefs: $el.data('colspan-defs') || {},
              showMeasureSys: 'imperial',
            },
            defaultColDef: {
              sortable: gridType === 'standard',
              unSortIcon: true,
              comparator: self.valueComparator,
              filter: true,
              colSpan: self.colSpanCallback,
              sort: $el.data('default-sort') || null,
              suppressMovable: true,
              suppressMenu: true,
              wrapText: true,
              autoHeight: true,
              minWidth: 200,
              maxWidth: 225,
            },
            columnDefs: $el.hasClass('OneLinkNoTx')
              ? $el.data('column-defs-raw')
              : $el.data('column-defs'),
            pagination:
              $el.data('total-rows') > 25 &&
              gridType !== 'transposed' &&
              $('body').hasClass('page-node-nvent_pim_product'),
            paginationPageSize: 25,
            rowData: $el.hasClass('OneLinkNoTx')
              ? $el.data('row-data-raw')
              : $el.data('row-data'),
            components: {
              cellRenderer: self.htmlRenderer,
            },
            isExternalFilterPresent: self.isExternalFilterPresent,
            doesExternalFilterPass: self.doesExternalFilterPass,
            domLayout: 'autoHeight',
            animateRows: true,
            onFilterChanged: (params) => {
              const ev = new CustomEvent('AGGridFilterChanged', {
                detail: { instanceId: id },
              });
              document.dispatchEvent(ev);
              self.setFiltersHeight(id);
              self.setStickyheader(params);
            },
            onColumnVisible: (event) => {
              // A column, or group of columns, was hidden / shown.
              // Ensure the header cell displays HTML if the grid is transposed
              // after redrawing columns.
              if (
                event.api.gridOptionsWrapper.gridOptions.metadata.gridType ===
                'transposed'
              ) {
                const $elements = $el.find('.ag-header-cell-text');
                self.htmlize($elements);
              }
            },
            onVirtualColumnsChanged: (event) => {
              // The list of rendered columns changed (only columns in the
              // visible scrolled viewport are rendered). Ensure the header cell
              // displays HTML if the grid is transposed.
              if (
                event.api.gridOptionsWrapper.gridOptions.metadata.gridType ===
                'transposed'
              ) {
                const $elements = $el.find('.ag-header-cell-text');
                self.htmlize($elements);
              }
            },
            onFirstDataRendered: () => {
              const ev = new CustomEvent('AGGridFirstDataRendered', {
                detail: { instanceId: id },
              });
              document.dispatchEvent(ev);
              self.initFacets(id);
            },
            onGridReady: (params) => {
              self.setFiltersHeight(id);
              self.setTableScroll();
              self.setSizeColumns(params);
              self.setStickyheader(params);
            },
            onGridSizeChanged: (params) => {
              self.setTableScroll();
              self.setColumnHeaderHeight(params);
              self.setStickyheader(params);
            },
            scrollbarWidth: 15,
          };
          const columnDefs = $el.hasClass('OneLinkNoTx')
            ? $el.data('column-defs-raw')
            : $el.data('column-defs');

          // Set minimum width for the first column

          if (columnDefs && columnDefs.length > 0) {
            if ($(window).width() <= 767) {
              columnDefs[0].minWidth = 200; // Adjust for mobile
              columnDefs[0].maxWidth = 200;
            } else {
              columnDefs[0].minWidth = 300; // Desktop default
              columnDefs[0].maxWidth = 300;
            }
          }

          // eslint-disable-next-line no-new
          new Grid(this, gridOptions);

          const columnsMeasureSys = $el.data('columns-by-measure-sys') || [];

          self.state.instances.push({
            id,
            gridOptions,
            columnsMeasureSys,
          });

          if (
            gridOptions.rowData.length <= 1 ||
            gridOptions.metadata.gridType === 'transposed' ||
            $('body').hasClass('page-node-nvent_pim_product_item')
          ) {
            $('.ag-grid-wrapper', context).addClass(
              'ag-grid-wrapper--one-column'
            );
          }

          // Set scroll position for buttons
          const $scrollButton = $('.js-scroll-button', context);

          $scrollButton.on('click', (e) => {
            const scrollPos = $(e.currentTarget).hasClass('scroll-left')
              ? '-=200px'
              : '+=200px';
            $('.ag-body-horizontal-scroll-viewport').animate(
              {
                scrollLeft: scrollPos,
              },
              'slow'
            );
          });

          // Scroll table when user scrolls on the extra scrollbar and vice versa
          const $topScroll = $('.ag-grid-top-scroll-viewport');
          const $mainScroll = $('.ag-body-horizontal-scroll-viewport');

          $topScroll.on('scroll', () => {
            $mainScroll.scrollLeft($topScroll.scrollLeft());
          });

          $mainScroll.on('scroll', () => {
            $topScroll.scrollLeft($mainScroll.scrollLeft());
          });
          $el.find('.ag-paging-panel').addClass('OneLinkNoTx');
          $el.find('.ag-paging-page-summary-panel').addClass('OneLinkNoTx');
        });
        if (module.drupal) {
          const handler = (system) => {
            self.updateMeasureSys(system.current);
          };
          if (Drupal.behaviors.measurementSystemToggle) {
            Drupal.behaviors.measurementSystemToggle.onChange(handler);
          } else {
            document.addEventListener(
              'MeasurementSystemToggleReady',
              function fn(e) {
                e.detail.toggle.onChange(handler);
              }
            );
          }
        } else {
          console.log('Calling to measurementSystemToggle.onChange()');
        }
      },
      /**
       * Updates the table to show information in the given measurement system.
       *
       * @param system
       *   The measurement system to show.
       * @param index
       *   Optional instance index to update.
       */
      updateMeasureSys(system, index) {
        const self = this;
        // eslint-disable-next-line no-restricted-syntax
        for (const i in self.state.instances) {
          if (index && i !== index) {
            // eslint-disable-next-line no-continue
            continue;
          }
          self.state.instances[i].gridOptions.metadata.showMeasureSys = system;
          if (
            self.state.instances[i].gridOptions.metadata.gridType ===
            'transposed'
          ) {
            self.state.instances[i].gridOptions.api.onFilterChanged();
            // eslint-disable-next-line no-continue
            continue;
          }

          const state = [];
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const x in self.state.instances[i].columnsMeasureSys.imperial) {
            state.push({
              colId: self.state.instances[i].columnsMeasureSys.imperial[x],
              hide: system !== 'imperial',
            });
          }
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const x in self.state.instances[i].columnsMeasureSys.metric) {
            state.push({
              colId: self.state.instances[i].columnsMeasureSys.metric[x],
              hide: system !== 'metric',
            });
          }
          self.state.instances[i].gridOptions.columnApi.applyColumnState({
            state,
          });
          // Recalculate columns height and scroll
          const params = self.state.instances[i].gridOptions;
          params.onGridSizeChanged(params);
        }
      },
      /**
       * Comparator to compare values to perform sorting.
       *
       * @param value1
       *   The first value in the cell to be compared.
       * @param value2
       *   The second value in the cell to be compared.
       * @returns {number}
       *   The result of comparison.
       *
       * @see https://www.ag-grid.com/javascript-data-grid/row-sorting/#custom-sorting
       */
      valueComparator(value1, value2) {
        const toComparableNumber = function fn(value) {
          const element = value.replace(/[-,]/g, '');
          const regex = /[+-]?\d+(\.\d+)?/g;
          const result = element.match(regex);
          if (result && result[0]) {
            return parseFloat(result[0]);
          }
          return null;
        };

        const number1 = toComparableNumber(value1);
        const number2 = toComparableNumber(value2);

        if (number1 === null && number2 === null) {
          return value1.localeCompare(value2);
        }
        if (number1 === null) {
          return -1;
        }
        if (number2 === null) {
          return 1;
        }

        return number1 - number2;
      },
      /**
       * Renders cell content as HTML.
       *
       * @param params
       *   Cell value object.
       * @returns {ChildNode|*}
       *   The DOM Node equivalent of the cell value, or the untouched cell
       *   value if the is_html attribute is false.
       *
       * @see https://www.ag-grid.com/javascript-data-grid/component-cell-renderer/#cell-renderer-component
       */
      htmlRenderer(params) {
        const self = Drupal.behaviors.agGrid;
        if (self.cellIsHtml(params)) {
          const template = document.createElement('template');
          template.innerHTML = params.value.trim();
          return template.content.firstChild;
        }
        return params.value;
      },
      /**
       * Determines if cell content is HTML or not.
       *
       * @param params
       *   Cell value object.
       * @returns {boolean}
       *   TRUE if the cell contains HTML, FALSE otherwise.
       */
      cellIsHtml(params) {
        return (
          params.is_html ||
          (Array.isArray(params.html_rows) &&
            params.html_rows.includes(params.rowIndex))
        );
      },
      /**
       * Wrapper of htmlRenderer to render the given $elements as HTML.
       *
       * @param $elements
       *   The elements to be rendered as HTML.
       */
      htmlize($elements) {
        const self = Drupal.behaviors.agGrid;
        $elements.each(function fn() {
          const $el = $(this);
          let value = '';
          if ($el.hasClass('processed')) {
            value = this.innerHTML;
          } else {
            value = $el.text();
            $el.addClass('processed');
          }
          const params = {
            value,
            is_html: true,
          };
          $el.html(self.htmlRenderer(params));
        });
      },
      /**
       * Sets external filters.
       *
       * @param filters
       *   The external filters to set, in the form
       *   {
       *    FILTER_ID_1: {
       *      values:[1..N]
       *    },
       *    ...
       *    FILTER_ID_N: {
       *      values:[1..N]
       *    }
       *  }
       */
      setFilters(filters) {
        const self = Drupal.behaviors.agGrid;
        self.state.externalFilters = filters;
        self.state.availableFiltersValues = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const instance of self.state.instances) {
          if (instance.gridOptions.metadata.gridType === 'transposed') {
            self.filterColumns(instance);
          } else {
            instance.gridOptions.api.onFilterChanged();
          }
        }
      },
      /**
       * Checks if the given filter {id, value} is in the list of available
       * filters values, this is used to determine if a facet value that has no
       * elements in the results (zero count), can still be included in the
       * the filters values.
       *
       * @param filter
       */
      isAvailableFilterValue(filter) {
        const self = Drupal.behaviors.agGrid;
        self.state.availableFiltersValues =
          self.state.availableFiltersValues || {};
        return (
          self.state.availableFiltersValues[filter.id] &&
          self.state.availableFiltersValues[filter.id].includes(filter.value)
        );
      },
      /**
       * Callback to know if an external filter is present.
       *
       * @returns {boolean}
       *   `true` if external filters are present or if this is a transposed
       *   grid type, `false` otherwise.
       *
       * @see https://www.ag-grid.com/javascript-data-grid/filter-external
       */
      isExternalFilterPresent() {
        return (
          this.metadata.gridType === 'transposed' ||
          Object.keys(Drupal.behaviors.agGrid.state.externalFilters).length > 0
        );
      },
      /**
       *
       * @param node
       * @returns {boolean}
       *   `true` if external filter passes, or if the row is in a the selected
       *   measurement system for transposed grid type, `false` otherwise.
       */
      doesExternalFilterPass(node) {
        const self = Drupal.behaviors.agGrid;
        const { gridOptions } = node.beans.gridOptionsWrapper;
        if (gridOptions.metadata.gridType === 'transposed') {
          return !(
            node.data.measureSys &&
            node.data.measureSys !== gridOptions.metadata.showMeasureSys
          );
        }

        let pass = true;
        const availableFiltersValues = {};
        const filtersProcessed = [];
        let filtersDidNotPass = 0;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const id in self.state.externalFilters) {
          const filter = self.state.externalFilters[id];
          if (
            !filter.equivalentId ||
            !filtersProcessed.includes(filter.equivalentId)
          ) {
            filtersProcessed.push(id);
            const includes = filter.values.includes(node.data[id]);
            if (!includes) {
              filtersDidNotPass += 1;
              availableFiltersValues[id] = node.data[id];
              availableFiltersValues[filter.equivalentId] =
                node.data[filter.equivalentId];
            }

            pass = pass && includes;
          }
        }
        if (filtersDidNotPass === 1) {
          self.state.availableFiltersValues =
            self.state.availableFiltersValues || {};
          // eslint-disable-next-line no-restricted-syntax
          for (const id of Object.keys(availableFiltersValues)) {
            if (!self.state.availableFiltersValues[id]) {
              self.state.availableFiltersValues[id] = [];
            }
            if (
              !self.state.availableFiltersValues[id].includes(
                availableFiltersValues[id]
              )
            ) {
              self.state.availableFiltersValues[id].push(
                availableFiltersValues[id]
              );
            }
          }
        }

        return pass;
      },
      /**
       * Callback to set column state visibility of the given AG Grid instance.
       *
       * @param {object} instance
       *   AG Grid instance.
       */
      filterColumns: (instance) => {
        const self = Drupal.behaviors.agGrid;
        let columnState = {};
        const areFiltersPresent =
          Object.keys(self.state.externalFilters).length > 0;
        // eslint-disable-next-line no-restricted-syntax
        for (const column of instance.gridOptions.columnDefs) {
          if (column.field === 'attribute_label') {
            // eslint-disable-next-line no-continue
            continue;
          }
          if (!columnState[column.field]) {
            columnState[column.field] = { colId: column.field, hide: null };
          }

          if (areFiltersPresent) {
            // eslint-disable-next-line no-restricted-syntax
            for (const row of instance.gridOptions.rowData) {
              if (self.state.externalFilters[row.attributeId]) {
                if (columnState[column.field].hide === true) {
                  // eslint-disable-next-line no-continue
                  continue;
                }
                columnState[column.field].hide = !self.state.externalFilters[
                  row.attributeId
                ].values.includes(row[column.field]);
              }
            }
          }
          if (columnState[column.field].hide === null) {
            columnState[column.field].hide = areFiltersPresent;
          }
        }
        columnState = Object.values(columnState);
        instance.gridOptions.columnApi.applyColumnState({ state: columnState });
      },
      /**
       * Callback to set column spanning.
       *
       * @param params
       *   The params object.
       * @returns {number}
       *   The number of columns to span.
       *
       * @see https://www.ag-grid.com/javascript-data-grid/column-spanning/#configuring-column-spanning
       */
      colSpanCallback: (params) => {
        const {
          colSpanDefs,
        } = params.api.gridOptionsWrapper.gridOptions.metadata;
        if (
          colSpanDefs[params.colDef.field] &&
          colSpanDefs[params.colDef.field][params.data.attributeId]
        ) {
          return colSpanDefs[params.colDef.field][params.data.attributeId];
        }
        return 1;
      },
      initFacets: (id) => {
        if (window.agGridFacetApi) {
          const facetApi = window.agGridFacetApi.instance(id);
          if (facetApi) {
            const defaultActive = (function fn() {
              if (window.location.search.substring(1)) {
                try {
                  return Object.values(
                    JSON.parse(
                      `{"${decodeURIComponent(
                        window.location.search
                          .substring(1)
                          .replace(/&/g, '","')
                          .replace(/=/g, '":"')
                      )}"}`
                    )
                  ).flatMap((facet) => {
                    const [
                      ,
                      ,
                      facetId,
                      ,
                      value,
                      facetIdEquivalency,
                      valueEquivalency,
                    ] = facet.split('|');
                    const defaultValues = [];
                    if (facetId && value) {
                      defaultValues.push(
                        facetValueIdGet(
                          facetId.toLowerCase().replace(/\W/g, '_'),
                          value
                        )
                      );
                      if (facetIdEquivalency && valueEquivalency) {
                        defaultValues.push(
                          facetValueIdGet(
                            facetIdEquivalency
                              .toLowerCase()
                              .replace(/\W/g, '_'),
                            valueEquivalency
                          )
                        );
                      }
                    } else {
                      const [facetId1, value1] = facet.split('|');
                      if (facetId1 && value1) {
                        defaultValues.push(
                          facetValueIdGet(
                            facetId1.toLowerCase().replace(/\W/g, '_'),
                            value1
                          )
                        );
                      }
                    }
                    return defaultValues;
                  });
                } catch (err) {
                  console.log(err.message);
                }
              }
              return [];
            })();
            facetApi.api.setFacets(false, defaultActive);

            if (!facetApi.api.getFacets().length) {
              $('.ag-grid-wrapper').addClass('ag-grid-wrapper--one-column');
            }

            if (module.drupal) {
              const handler = (system) => {
                facetApi.api.setMeasurementSystem(system.current);
              };
              if (Drupal.behaviors.measurementSystemToggle) {
                Drupal.behaviors.measurementSystemToggle.onChange(handler);
              } else {
                document.addEventListener(
                  'MeasurementSystemToggleReady',
                  function fn(e) {
                    e.detail.toggle.onChange(handler);
                  }
                );
              }
            } else {
              console.log(
                'Calling to measurementSystemToggle.onChange() facetApi'
              );
            }
            if (defaultActive && defaultActive.length) {
              facetApi.api.apply();
            }
          }
        } else {
          // No facets API instance, so we need the table in full size mode.
          $('.ag-grid-wrapper').addClass('ag-grid-wrapper--one-column');
        }
      },
      /**
       * Set a height to the facets filters.
       */
      setFiltersHeight: (id) => {
        if (window.agGridFacetApi) {
          const facetApi = window.agGridFacetApi.instance(id);
          if (facetApi) {
            const agGridResults = $('.ag-grid-results');
            const resultsHeight = agGridResults ? agGridResults.height() : 0;
            facetApi.api.setHeight(resultsHeight);
            window.addEventListener('resize', () => {
              facetApi.api.setHeight(resultsHeight);
            });
          }
        }
      },
      /**
       * Set scroll controls and a second scrollbar on top of the table
       */
      setTableScroll: () => {
        const $agGridResults = $('.ag-grid-results');
        const $scrollWrapper = $('.ag-body-horizontal-scroll-container');
        const $scrollPinned = $('.ag-pinned-left-header:not(.ag-hidden)');
        const scrollWidth = $('.ag-body-horizontal-scroll-viewport').width();
        const tableWidth = $scrollWrapper.width();
        if ($scrollWrapper.height() > 0) {
          // If table is scrollable, display scroll controls
          $agGridResults.addClass('ag-grid-results--scrollable');

          // If table has a pinned column, set spacer to match the default scroll
          if ($scrollPinned.length > 0) {
            $('.ag-grid-top-scroll').addClass('ag-grid-top-scroll--pinned');
            $('.ag-horizontal-left-spacer').css('width', $scrollPinned.width());
          }

          // Set top scrollbar size
          $('.ag-grid-top-scroll-viewport').css('width', scrollWidth);
          $('.ag-grid-top-scroll-container').css('width', tableWidth);
        } else {
          $agGridResults.removeClass('ag-grid-results--scrollable');
        }
      },
      /**
       * Set sticky header for table when user scroll
       */
      setStickyheader: (params) => {
        const $agGrid = $('.ag-grid');
        const $header = $('.ag-header');
        const $topScrollbar = $('.ag-grid-top-scroll');
        const displayStatus = $('.ag-grid-results').hasClass(
          'ag-grid-results--scrollable'
        );
        const $scrollHeight = displayStatus ? $topScrollbar.outerHeight() : 0;
        const $gridControl = $('.ag-grid-controls');
        const $tabsTitles = $('.tabs-block__tab__titles');
        const rowDataLength = params.api.getDisplayedRowCount();
        const mobileHeight = $('.header').outerHeight();
        const isLogged = $('.toolbar-fixed').length > 0;
        const extraSpace = displayStatus ? 5 : 20;
        const $toolBarSpace = isLogged
          ? $('.toolbar-bar').outerHeight() + $scrollHeight + extraSpace
          : 0;
        const tabsTitlesHeight = $tabsTitles.outerHeight();
        const desktopTop =
          mobileHeight +
          tabsTitlesHeight +
          $gridControl.outerHeight() +
          $scrollHeight;
        const desktopHeight = isLogged
          ? desktopTop - $toolBarSpace
          : desktopTop;
        const topSpacing =
          window.innerWidth <= 720
            ? mobileHeight + $scrollHeight + $gridControl.outerHeight()
            : desktopHeight;
        const topControlSpacing =
          window.innerWidth <= 720
            ? mobileHeight
            : mobileHeight + tabsTitlesHeight - $toolBarSpace;
        const topScrollSpacing =
          window.innerWidth <= 720
            ? mobileHeight + $gridControl.outerHeight()
            : desktopHeight - $scrollHeight;
        if (!$agGrid.hasClass('transposed')) {
          $header.css('top', rowDataLength > 8 ? topSpacing : 0);
          $gridControl.css('top', rowDataLength > 8 ? topControlSpacing : 0);
          $topScrollbar.css('top', rowDataLength > 8 ? topScrollSpacing : 0);
        }
      },
      /**
       * AutoHeight doesn't work for column headers, so we need to set them to
       * the height of the tallest one.
       */
      setColumnHeaderHeight: (params) => {
        const padding = 14;
        const columnHeaderTexts = [
          ...document.querySelectorAll('.ag-header-cell-text'),
        ];
        const columnHeaderHeights = columnHeaderTexts.map(
          (columnText) => columnText.clientHeight
        );
        let maxColumnHeaderHeight = Math.max(...columnHeaderHeights);
        maxColumnHeaderHeight =
          maxColumnHeaderHeight + padding < 50
            ? 50
            : maxColumnHeaderHeight + padding;

        params.api.setHeaderHeight(maxColumnHeaderHeight);
      },
      /**
       * Set the width of the columns to fit the width of the container.
       */
      setSizeColumns: (params) => {
        const self = Drupal.behaviors.agGrid;
        const columns = params.columnApi.getAllColumns();

        if (columns.length > 5) {
          self.setMinColumnWidth(params);
        } else if (columns.length <= 2) {
          params.api.sizeColumnsToFit();
          window.addEventListener('resize', () => {
            setTimeout(function st() {
              params.api.sizeColumnsToFit();
            });
          });
        } else if ($(window).width() > 919) {
          params.columnApi.autoSizeAllColumns();
        }
      },
      /**
       * Set the width of the columns according to the minimum width possible.
       */
      setMinColumnWidth: (params) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = 'bold 16px Arial';
        let padding = 70;

        const {
          columnDefs,
          rowData,
        } = params.api.gridOptionsWrapper.gridOptions;
        const maxWidths = new Map();

        // Measure headers by jquery to get the width of the trimmed text.
        const columnHeaderTexts = [
          ...document.querySelectorAll('.ag-header-cell-text'),
        ];
        // Add conditional to set the minimum width in mobile and avoid text truncate
        const columnHeaderWidths = columnHeaderTexts.map(
          (columnText) => columnText.clientWidth + padding
        );

        // Measure columns by canvas to obtain the max width.
        rowData.forEach((row) => {
          columnDefs.forEach((column, i) => {
            const headerWidth = columnHeaderWidths[i];
            let { width } = context.measureText(row[column.field]);
            if (headerWidth !== undefined && headerWidth > width) {
              width = headerWidth;
            }
            maxWidths.set(column.field, width);
          });
        });
        let colWidth = 130;
        // Set column width.
        columnDefs.forEach((column, index) => {
          padding = column.field === 'label' ? 60 : 50;
          if (index !== 0) {
            if (maxWidths.get(column.field) === 0) {
              colWidth = 150;
            } else if (
              maxWidths.get(column.field) < 230 &&
              maxWidths.get(column.field) > 170
            ) {
              colWidth = 196;
            } else if (
              maxWidths.get(column.field) < 171 &&
              maxWidths.get(column.field) > 100
            ) {
              colWidth = 176;
            } else if (
              maxWidths.get(column.field) < 55 &&
              maxWidths.get(column.field) > 31
            ) {
              colWidth = 160;
            } else if (maxWidths.get(column.field) < 30) {
              colWidth = 140;
            }
          } else {
            colWidth = maxWidths.get(column.field) + padding;
          }
          params.columnApi.setColumnWidth(column.field, Math.ceil(colWidth));
        });
      },

      instance: (id) => {
        const agGrid = Drupal.behaviors.agGrid.state.instances
          .filter((obj) => obj.id === id)
          .pop();

        if (!agGrid) {
          console.log('agGrid instance not found');
        }
        return agGrid;
      },
    },
  };

  if (!module.drupal) {
    window.Drupal = {
      behaviors: {},
    };
  }

  if (window.Drupal.behaviors[module.name] === undefined) {
    window.Drupal.behaviors[module.name] = module.instance;
  }

  if (module.drupal) {
    module.instance.attach($context, {});
  } else {
    window.onload = () => {
      console.log(`${module.name} loaded.`);
      module.instance.attach(document, {});
    };
  }
  $('#copy_table').on('click', function () {
    const $el = $('.ag-grid');
    const $root = $('.copy-table');
    $root.find('tbody').empty();
    const $headerCells = $el.find('.ag-header .ag-header-cell');
    const $rowCells = $el.find('.ag-center-cols-container .ag-row');
    const $firstRow = $('<tr>').appendTo($root);
    const idsArray = [];
    $($headerCells).each(function () {
      $('<td>', { class: '' })
        .text($(this).find('.ag-header-cell-text').text())
        .appendTo($firstRow);
    });
    if ($('.ag-pinned-left-cols-container .ag-row .ag-cell').length > 0) {
      const $leftCols = $('.ag-pinned-left-cols-container');
      $($leftCols)
        .find('.ag-cell')
        .each(function (index) {
          idsArray[index] = $(this).find('.ag-cell-value ').text();
        });
    }
    $($rowCells).each(function (index, row) {
      const $row = $('<tr>', { class: '' }).appendTo($root);
      if ($('.ag-pinned-left-cols-container .ag-row .ag-cell').length > 0) {
        $('<td>').text(idsArray[index]).appendTo($row);
      }
      $(row)
        .find('.ag-cell')
        .each(function () {
          $('<td>', { class: '' })
            .text($(this).find('.ag-cell-value ').text())
            .appendTo($row);
        });
    });
    // Select the table
    const table = $('#copy-to-clipboard');

    // Get the rows and columns of the table
    const rows = table.find('tr');
    let columns;

    // Initialize a string to hold the table structure
    let tableStructure = '';

    // Loop through each row of the table
    rows.each(function () {
      columns = $(this).find('td');

      // Loop through each column of the row
      columns.each(function () {
        tableStructure += `${$(this)
          .css({
            'font-weight': 'normal',
            'font-size': '18px',
            'max-width': '25px',
          })
          .text()}\t`;
      });

      // Add a line break after each row
      tableStructure += '\n';
    });

    // Create a temporary hidden textarea to hold the table structure
    const tempTextArea = $('<textarea>');
    tempTextArea.val(tableStructure).appendTo('body').select();

    // Copy the table structure to the clipboard
    document.execCommand('copy');

    // Remove the temporary textarea
    tempTextArea.remove();

    // TO show tooltip message.
    $('.copy-button-wrapper span').addClass('active');
    setTimeout(function () {
      $('.copy-button-wrapper span').removeClass('active');
    }, 1000);
  });
})(jQuery, Drupal);
